import { Request, Response } from "express"
import { Errors } from "../errors";
import * as moment from "moment"
import { WorkingDay, OrderWeekDay, FlatWorkingDay, WorkingHours, AggregateLookupResponse, DeliveryWorkingDay, RestaurantAggregateResponse, DeliveryHours, DeliveryDay, DayHour, WeekDay } from "./restaurant/models";
import { config } from "../config/config";
import { initService } from "../middlewares/init-data/service";
import { Language } from "../middlewares/language";
import { authService, IJWTData } from "./auth/service";
import { getFeatureIcon } from "./features-icons";

var uniqid = require('uniqid');
const authUrl = `${config.api.auth}/auth`;
// const authUrl = `/api/auth-svc/1.0/auth`;

export const headers = {
  "Content-Type": "application/json",
  'Client-Model': config.headers.clientModel,
  'Client-Version': config.headers.clientVersion,
  'X-Client-Id': config.webClientID,
}


export const flatAreaZones = (zones) => {

  return zones.reduce((zonesObj, zone) => {
    zonesObj[zone.ref.areaUUID] = zonesObj[zone.ref.areaUUID] || [];
    
    zonesObj[zone.ref.areaUUID].push({
      uuid: zone.uuid,
      name: zone.data.name,
    });
    
    return zonesObj;
  }, {});

}

export function refreshTokenFunction(req) {
  headers['X-Device-Id'] = req.cookies.payload;
  return fetch(authUrl, {
    method: 'PUT',
    headers,
    body: req.cookies[config.cookie.refreshToken]
  })
}

export function requestAfterRefreshToken(url, req) {
  headers['X-Device-Id'] = req.cookies.payload;
  headers['lang'] = req.cookies.lang;
  headers['Device-Model'] = req.get('User-Agent');
  headers['Authorization'] = `Bearer ${req.cookies.Authorization}`;
  
  return fetch(url, {
    method: req.method,
    headers,
    body: req.body
  })
}

export async function loginAsGuest(req, response) {
  if (!req.cookies[config.cookie.deviceID]) {
    setCookie(req, response, config.cookie.deviceID, uniqid());
  }
  let res = await authService.guestAuthenticate(req, response);
  setCookie(req, response, config.cookie.jwt, res.accessToken)
  setCookie(req, response, config.cookie.refreshToken, res.refreshToken);
  return res;
}

export async function handleStatus(response, req) {
  if (response.status >= 200 && response.status < 300) {
   return response
  } else {
    if (response.status == 401 && response.url.indexOf(authUrl)<0 && req.cookies[config.cookie.refreshToken]) {
      let res = await refreshTokenFunction(req);
      if (res.status >= 200 && res.status < 300) {
        let result = await res.json();
        setCookie(req, response, config.cookie.jwt, result.accessToken);
        setCookie(req, response, config.cookie.refreshToken, result.refreshToken);
        
        let res2 = await requestAfterRefreshToken(response.url, req);
        if (res2.status >= 200 && res2.status < 300) {
          return res2;
        } else {
          await loginAsGuest(req, response);
          let res2 = await requestAfterRefreshToken(response.url, req);
          return res2;
        }
      } else {
       await loginAsGuest(req, response);
       let res2 = await requestAfterRefreshToken(response.url, req);
       return res2;
      }
    } else if (response.url.indexOf(authUrl) >= 0 && !req.cookies[config.cookie.refreshToken] && (response.status >= 400 && response.status < 500)) {
      await loginAsGuest(req, response);
      let res2 = await requestAfterRefreshToken(response.url, req);
      return res2;
    }
    else {
      throw response.status
    }
  }
}

export function getRequestWithStatusCode(req, url: string, jwt: string, language: string = req.cookies[config.cookie.language]) {
  const headers = Object.assign({}, (
    req.cookies[config.headers.xTracking]
      ? {
        [config.headers.xTracking]: req.cookies[config.headers.xTracking]
      }
      : {}
  ), {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${jwt}`,
    'X-Client-Id': config.webClientID,
    'lang': language,
    'Client-Model': config.headers.clientModel,
    'Client-Version': config.headers.clientVersion,
    'Device-Model': req.get('User-Agent'),
    'X-Device-Id': req.cookies.payload,
    'userCompany': req.cookies[config.cookie.company] ? JSON.parse(req.cookies[config.cookie.company]).place_id : '',
    'userZone': req.cookies[config.cookie.zone],
    'userArea': req.query.area || req.cookies[config.cookie.area]
  });
  
  if (req.cookies.long && req.cookies.lat) {
    headers['userLong'] = req.cookies.long;
    headers['userLat'] = req.cookies.lat;
  }

  return fetch(url, {
    method: 'GET',
    headers: headers
  })
}

export function getRequest<T>(req, url: string, jwt: string, language: string = req.cookies[config.cookie.language]): Promise<T> {
  const headers = Object.assign({}, (
    req.cookies[config.headers.xTracking]
      ? {
        [config.headers.xTracking]: req.cookies[config.headers.xTracking]
      }
      : {}
  ), {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${jwt}`,
    'X-Client-Id': config.webClientID,
    'lang': language,
    'Client-Model': config.headers.clientModel,
    'Client-Version': config.headers.clientVersion,
    'Device-Model': req.get('User-Agent'),
    'X-Device-Id': req.cookies.payload,
    'userCompany': req.cookies[config.cookie.company] ? JSON.parse(req.cookies[config.cookie.company]).place_id : '',
    'userZone': req.cookies[config.cookie.zone],
    'userArea': req.query.area || req.cookies[config.cookie.area]
  });

  if (req.cookies.long && req.cookies.lat) {
    headers['userLong'] = req.cookies.long;
    headers['userLat'] = req.cookies.lat;
  }
  return fetch(url, {
    method: 'GET',
    headers: headers
  })
    .then(response => handleStatus(response, req))
    .then(response => {
      return <T>response && <T>response.json().then(res => {
        res[config.headers.xTracking] = response.headers.get(config.headers.xTracking)
        return res;
      })
    })
}

export function postRequest<T, S>(req, url: string, jwt: string, body: T): Promise<S> {
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${jwt}`,
    'X-Client-Id': config.webClientID,
    'lang': req.cookies[config.cookie.language],
    'Client-Model': config.headers.clientModel,
    'Client-Version': config.headers.clientVersion,
    'Device-Model': req.get('User-Agent'),
    'X-Device-Id': req.cookies.payload,
    'userCompany': req.cookies[config.cookie.company] ? JSON.parse(req.cookies[config.cookie.company]).place_id : '',
    'userZone': req.cookies[config.cookie.zone] || '',
    'userArea': req.query.area || req.cookies[config.cookie.area]
  }

  if (req.cookies.long && req.cookies.lat) {
    headers['userLong'] = req.cookies.long;
    headers['userLat'] = req.cookies.lat;
  }

  return fetch(url, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(body)
  })
    .then(response => handleStatus(response, req))
    .then(response => <S>response.json())
}

export function setCookie(req: Request, res: Response, key, value) {
  res.cookie && res.cookie(key, value, { maxAge: 30 * 86400 * 1000 })
  req.cookies[key] = value
}

export const getWorkingDays = (deliveryHours: DeliveryHours[]) => {
    var dailyWorkingHours: DeliveryDay[] = Object.keys(deliveryHours).map((key) => ({weekDay: key.toUpperCase() as WeekDay, hours: deliveryHours[key]}));

    const result = [...dailyWorkingHours].sort((a: DeliveryDay, b: DeliveryDay) => {
      let dayA = OrderWeekDay[a.weekDay.toUpperCase()];
      let dayB = OrderWeekDay[b.weekDay.toUpperCase()];
      return (dayA > dayB ? 1 : ((dayB > dayA) ? -1 : 0));
    }).reduce((days: Array<DeliveryDay[]>, currentDay: DeliveryDay) => {
      var workingHours = {
        from: currentDay.hours[0] ? currentDay.hours[0].from : null,
        to: currentDay.hours[currentDay.hours.length -1]? currentDay.hours[currentDay.hours.length -1].to : 0
      }
  
      if (days.length && days[days.length - 1][0].hours[0]) {
        days[days.length - 1][0].hours[0].from == workingHours.from
          ? days[days.length - 1].push(Object.assign({}, currentDay, { hours: [workingHours] }))
          : days.push([Object.assign({}, currentDay, { hours: [workingHours] })])
      } else {
        days[0] = [Object.assign({}, currentDay, { hours: [workingHours] })];
      }
  
      return days;
  
    }, []);
  return result;
};

export const weekHoursRanges = (deliveryDays:DeliveryDay[],language) => {
  let local = language == 'AR' || language == 'ar' ? 'ar-ly' : 'en'
 //initiate ranges with first day in week
 let ranges = [{
  title: moment(deliveryDays[0].weekDay, 'dddd').locale(local).format("ddd"),
  value: moment(deliveryDays[0].hours[0].from * 1000).locale(local).format("hh:mm A") +
    '-' + moment(deliveryDays[0].hours[deliveryDays[0].hours.length - 1].to * 1000).locale(local).format("hh:mm A")
}]
  //loop should start from second day in week
  for (let i = 0; i < deliveryDays.length; i++) {
    const len = deliveryDays[i].hours.length
    let currentRange = {
      title: moment(deliveryDays[i].weekDay, 'dddd').locale(local).format("ddd"),
      value: moment(deliveryDays[i].hours[0].from * 1000).locale(local).format("hh:mm A") +
        '-' + moment(deliveryDays[i].hours[len - 1].to * 1000).locale(local).format("hh:mm A")
    } 
    //check if current day hours match last day in array of ranges
    if (ranges[ranges.length - 1].value == currentRange.value) 
    {
      //add day name in previous range added

      ranges[ranges.length - 1].title = ranges[ranges.length - 1].title.split('-')[0] + ' - ' + currentRange.title
    }
    //check if current day is last day in week and hours match first range (friday hours matches saturday hours range)
    else if (i == (deliveryDays.length - 1) && ranges[0].value == currentRange.value) {

      //add day name in first range in week
    let prevTitle=ranges[0].title.split('-')[1]?ranges[0].title.split('-')[1]:ranges[0].title
    ranges[0].title = currentRange.title +' - '+ prevTitle
    }
    else {
      ranges.push(currentRange)
    }

   }

return ranges

};


export const flatWorkingDays = (dailyWorkingHours: WorkingDay[]) => {
  return dailyWorkingHours.reduce((workingDaysObj: FlatWorkingDay, currentDay: WorkingDay) => {
    workingDaysObj[currentDay.weekDay] = {
      weekDay: currentDay.weekDay,
      closed: currentDay.closed,
      workingHours: Object.assign({}, currentDay.workingHours)
    }

    return workingDaysObj
  }, {})
}

export const isRestaurantOpened = (openingTime: string, closingTime: string) => {
  let oldFormat = 'HH:mm:ss';
  let newFormat = 'HHmmss';
  openingTime = moment(openingTime, oldFormat).format(newFormat);
  closingTime = moment(closingTime, oldFormat).format(newFormat);
  let timeNow = moment().format(newFormat);  // getting current time from user's local device
  // but, should API return the opening/closing time with timezone to solve it forever
  return openingTime == closingTime || // open 24 hours
    (openingTime < closingTime && openingTime < timeNow && closingTime > timeNow) ||  // both open and close in the same day
    (
      openingTime > closingTime && // open <  midnight close after midnight 10 pm to 2 am
      (
        (openingTime < timeNow && closingTime < timeNow) || // <  midnight part 11 pm
        (openingTime > timeNow && closingTime > timeNow)  // after midnight part 1 am
      )
    );
}


export const getRestaurtnOrBranchShortcode=(params: string[])=>{
  let removeCount = params.includes('ar') ? 2 : 1;
  let restaurantOrBranch = params.slice(removeCount).filter((p) => p.includes('-') && !['scanned', 'photo', 'menu', 'review'].includes(p.split('-')[0]));
  return restaurantOrBranch.slice(restaurantOrBranch.length - 2);
}
export const flatCities = (cities) => {
  return cities.reduce(function (citiesObj, city) {
    citiesObj[city.uuid] = {
      uuid: city.uuid,
      countryUUID: city.ref.countryUUID,
      name: city.data.name,
    };

    return citiesObj;
  }, {});
}
export const flatLookupsAreas = (areas) => {

  return areas.reduce((areasObj, area) => {
    areasObj[area.uuid] = Object.assign({}, area.data, area.ref);
    return areasObj;
  }, {});
}

export const dateFromNow = (date) => {
  let today: number = new Date().getTime();
  let lastUpdate: number = new Date(date).getTime();
  let ago: number = (today - lastUpdate) / 1000;

  let min: number = 60;

  let hour: number = min * min;

  let day: number = hour * 24;

  if (ago >= day) {
    return parseInt("" + (ago / day)) + ' day(s) ago';
  }
  else if (ago >= hour) {
    return parseInt("" + (ago / hour)) + ' hour(s) ago';
  }
  else if (ago >= min) {
    return parseInt("" + (ago / min)) + ' min(s) ago';
  }
  else {
    return parseInt("" + ago) + ' sec(s) ago';
  }
}

export const isFrom24Hours = (date) => {
  let from24 = moment().subtract(24, 'hours');
  return moment(new Date(date)).isSameOrAfter(from24);
}
export const isFrom6Hours = (date) => {
  let from6 = moment().subtract(6, 'hours');
  return moment(new Date(date)).isSameOrAfter(from6);
}
export const URLBuilder = {
  /* A tail is ...
  * ""
  * scanned-menu
  * branches
  * photos
  * photo-{shortCode}
  * reviews
  * reviews-{short-code}
  * menus-{short-code}
  */
  dasher(value) {
    if (value) {
      return value.toLowerCase().replace(/[&\/\\#,+()$~%.":*?<>{} ]/g, '-').replace(/'/g, '').split("").reduce((acc, i) => {
        if (i == "-" && acc.last == "-") return acc
        else return { last: i, res: acc.res + i }
      }, { last: "", res: "" }).res
    }
    else {
      return ''
    }
  },

  restaurantURL(rName, rId, city = 'cairo', tail, language, branch?) { // branch param syntax is: {BRANCH_AREA}-{BRANCH_SHORTCODE} for example: maadi-q7f4
    var addingTail = tail && `/${tail}`

    if (language == 'AR' || language == 'ar')
      return `/ar/${this.dasher(city) || 'القاهره'}/${this.dasher(rName)}-${rId}${branch ? '/' + branch : ''}${addingTail}`
    else
      return `/${this.dasher(city) || 'cairo'}/${this.dasher(rName)}-${rId}${branch ? '/' + branch : ''}${addingTail}`
  },

  branchURL(rName, rId, area, bId, city, tail, language) {
    var addingTail = tail && `/${tail}`
    return `${this.restaurantURL(rName, rId, city, '', language)}/${this.dasher(area)}-${bId}${addingTail}`;
  },

  handleLanguageInURL(language: string) {
    if (language == "ar" || language == "AR") return "/ar"
    else return ""
  },

  filterDineout(city, area, mood, dish, features, language, isOpen, type = "") {
    var addingArea = area && `/${this.dasher(area)}` || "";
    var addingLanguage = this.handleLanguageInURL(language);
    var addingCity = city && `/${this.dasher(city)}` || "";
    var addingMood = mood && `/mood-${this.dasher(mood)}` || "";
    var addingDish = dish && `/dish-${this.dasher(dish)}` || "";
    var addingFeature = features && `/feature-${features.reduce((acc, i) => acc + "," + this.dasher(i))}` || ""
    var params;
    if (isOpen != null) params = `?isopen=${isOpen}`
    else params = "";
    if (type) {
      return `${addingLanguage}${addingCity}/dineout${addingArea}/${type}-restaurants${addingMood}${addingDish}${addingFeature}${params}`
    } else {
      return `${addingLanguage}${addingCity}/dineout${addingArea}${addingMood}${addingDish}${addingFeature}${params}`
    }
  },

  filterDelivery(city, area, dishTag, features, language, isOpen) {
    var addingArea = area && `/${this.dasher(area)}` || ""
    var addingCity = city && `/${this.dasher(city)}` || ""
    var addingLanguage = this.handleLanguageInURL(language)
    var addingDishTag = dishTag && `/dish-${this.dasher(dishTag)}` || ""
    var addingFeature = features && `/features-${features.reduce((acc, i) => acc + "," + this.dasher(i))}` || ""
    var params
    if (isOpen != null) params = `?isopen=${isOpen}`
    else params = ""

    return `${addingLanguage}${addingCity}/delivery${addingArea}${addingDishTag}${addingFeature}${params}`
  },
  
  offers(city, area, dishTag, features, language, isOpen) {
    var addingArea = area && `/${this.dasher(area)}` || ""
    var addingCity = city && `/${this.dasher(city)}` || ""
    var addingLanguage = this.handleLanguageInURL(language)
    var addingDishTag = dishTag && `/dish-${this.dasher(dishTag)}` || ""
    var addingFeature = features && `/features-${features.reduce((acc, i) => acc + "," + this.dasher(i))}` || ""
    var params
    if (isOpen != null) params = `?isopen=${isOpen}`
    else params = ""

    return `${addingLanguage}${addingCity}/delivery${addingArea}${addingDishTag}${addingFeature}${params}/offers`
  },
  

  filterDishDelivery(city, area, dishTag, features, language, isOpen) {
    var addingArea = area && `/${this.dasher(area)}` || ""
    var addingCity = city && `/${this.dasher(city)}` || ""
    var addingLanguage = this.handleLanguageInURL(language)
    var addingDishTag = dishTag && `/dishes-${this.dasher(dishTag)}` || ""
    var addingFeature = features && `/features-${features.reduce((acc, i) => acc + "," + this.dasher(i))}` || ""
    var params
    if (isOpen != null) params = `?isopen=${isOpen}`
    else params = ""

    return `${addingLanguage}${addingCity}/delivery${addingArea}${addingDishTag}${addingFeature}${params}`
  },
 
  search(city, keyword, language) {
    var addingCity = city && `/${this.dasher(city)}` || ""
    var addingKeyword = keyword && `/search-${this.dasher(keyword)}?query=${this.dasher(keyword)}` || ""
    var addingLanguage = this.handleLanguageInURL(language)

    return `${addingLanguage}${addingCity}${addingKeyword}`
  },

  staticPages(city, language, page) {
    var addingCity = city && `/${this.dasher(city)}` || "";
    var addingLanguage = this.handleLanguageInURL(language);

    return `${addingLanguage}${addingCity}/${page}`;
  },

  cvm(language, promoName) {
    return this.staticPages('', language, `offers/${promoName}`);
  },

  privacy(city = '', language) {
    return this.staticPages(city, language, 'privacy');
  },

  terms(city = '', language) {
    return this.staticPages(city, language, 'terms');
  },

  careers(city = '', language) {
    return this.staticPages(city, language, 'careers');
  },

  aboutUs(city = '', language) {
    return this.staticPages(city, language, 'about-us');
  },

  userProfile(userShortCode, userName, language, tail = '') {
    var addingLanguage = this.handleLanguageInURL(language)
    var addingUserName = this.dasher(userName.split(" ")[0])
    var addingTail = tail && `/${tail}`
    return `${addingLanguage}/users/${addingUserName}-${userShortCode}${addingTail}`
  },

  myOrders(language) {
    var addingLanguage = this.handleLanguageInURL(language)
    return `${addingLanguage}/myorders`
  },
  orderPage(language,params) {
    var addingLanguage = this.handleLanguageInURL(language)
    var orderShortCode = (language == Language.ARABIC) ? params[0] : params[1]
  
    return `${addingLanguage}/orders/${orderShortCode}`
    
  },
  orderTracking(language,params) {
    var addingLanguage = this.handleLanguageInURL(language)
    var orderShortCode = (language == Language.ARABIC) ? params[0] : params[1]
  
    return `${addingLanguage}/tracking/${orderShortCode}`
  },
  referral(language,params) {
    var addingLanguage = this.handleLanguageInURL(language)
    var referralCode = (language == Language.ARABIC) ? params[0] : params[1]
  
    return `${addingLanguage}/ref/${referralCode}`
  },
  tripTracking(language,params) {
    var addingLanguage = this.handleLanguageInURL(language)
    var tripShortCode = (language == Language.ARABIC) ? params[0] : params[1]
  
    return `${addingLanguage}/trip-tracking/${tripShortCode}`
  },
  mySettings(language) {
    var addingLanguage = this.handleLanguageInURL(language)
    return `${addingLanguage}/settings`
  },

  promo(language) {
    var addingLanguage = this.handleLanguageInURL(language)
    return `${addingLanguage}/promo`
  },

  gifting(language) {
    var addingLanguage = this.handleLanguageInURL(language)
    return `${addingLanguage}/giftmeals`
  },
  myAddressBook(language) {
    var addingLanguage = this.handleLanguageInURL(language)
    return `${addingLanguage}/settings#address-book-tab`
  },
}

export const removeDashes = (text) => {
  return text.split('-').join(' ')
}

export const capitalizeFirstLetter = (text) => {
  let cleanText = removeDashes(text);
  return cleanText.charAt(0).toUpperCase() + cleanText.slice(1);
}

export const handleLanguage = (lang, req, res) => {
  if (lang == "ar") lang = "AR"
  else lang = "EN"
  setCookie(req, res, config.cookie.language, lang)

  // if (req.cookies[config.cookie.language] != lang) {
  //   return Promise.all([initService.getLookups(req, req.cookies[config.cookie.jwt])])
  //     .then((lookups: AggregateLookupResponse[]) => {
  //       req.lookups = lookups[0];
  //       return lang;
  //     })
  // }

  return Promise.resolve(lang)
}

export const cityAreaFromURL = (params, lang, lookups: AggregateLookupResponse, req?, res?) => {
  let cityName: string;
  let areaName: string;
  if (lang == Language.ARABIC) {
    cityName = params[1];
    areaName = params[2];
  } else {
    cityName = params[0];
    areaName = params[1];
  }
  let city = lookups.cities.find(city => URLBuilder.dasher(city.data.name) == cityName || URLBuilder.dasher(city.data.otherName) == cityName);
  let area = lookups.areas.find(area => URLBuilder.dasher(area.data.name) == areaName);
  let cityUUID = city ? city.uuid : null;
  let areaUUID = area ? area.uuid : null;

  if (req && res) {
    let userArea = req.cookies[config.cookie.area];
    if (!userArea && areaUUID) { // set user city/area cookie if not fount in cookie
      setCookie(req, res, config.cookie.area, areaUUID);
      setCookie(req, res, config.cookie.city, area.ref.cityUUID);
    }
  }

  return {
    urlCityUUID: cityUUID,
    urlAreaUUID: areaUUID
  }
}
export const cityFromURL = (params, lang, lookups: AggregateLookupResponse, req?, res?) => {
  let cityName: string;
  if (lang == Language.ARABIC) {
    cityName = params[1];

  } else {
    cityName = params[0];
  }
  let city = lookups.cities.filter(city => URLBuilder.dasher(city.data.name) == cityName)[0];
  let cityUUID = city ? city.uuid : null;

  if (req && res) {
    let userCity = req.cookies[config.cookie.city];
    if (!userCity && cityUUID) { // set user cit cookie if not found in cookie

      setCookie(req, res, config.cookie.city, cityUUID);
    }
  }

  return {
    urlCityUUID: cityUUID,
  }
}
export const formatTime = (timeParam) => {
  var time = timeParam.split(':');
  return time[0] + ":" + time[1];
}